module.exports = __webpack_public_path__ + "static/img/fuchouzhe.c0f37de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/productBanner/man/banner/fuchouzhe.jpg
// module id = V5Tn
// module chunks = 0